var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FrMyAccessReviewTable',{attrs:{"default-sort":"role.name","fields":_vm.fields,"grant-type":"role"}})
}
var staticRenderFns = []

export { render, staticRenderFns }